module.exports = __webpack_public_path__ + "static/ss18.1b75eedc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/studysmart/ss/ss18.jpg
// module id = 1195
// module chunks = 81679748166845